<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRastreabilidadeBungeEmpresa',
    componentOptions: {
        title: 'RastreabilidadeEmpresa',
        actions: [
            [
                {
                    name: 'Rastreabilidade',
                    iconClass: 'lyra-icon bunge-rastreabilidade',
                    showView: false,
                    action: 'abrir',
                    route: 'RastreabilidadeEmpresa'
                }
            ]
        ]
    },

    methods: {
        abrir() {
            if (this.$route.name !== 'RastreabilidadeEmpresa') {
                this.$router.push({ name: 'RastreabilidadeEmpresa' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
